import CartNavbar from './CartNavbar';
import fabricImage from '../assets/FABRIC.png';

const CardHeader = () => {
  return (
    <div
      className="h-[40vh] min-h-[250px] mb-4 bg-customRed bg-cover bg-center flex flex-col w-full overflow-hidden relative"
      style={{
        backgroundImage: `url(${fabricImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
      id="SubHeader"
    >
      {/* Navbar positioned at the top */}
      <div className="relative z-10 w-full mb-10">
        <CartNavbar />
      </div>
      <div className="relative z-0 container text-center mx-auto mt-20 md:px-20 lg:px-32 text-white"></div>
      <div className="relative z-0 container text-center mx-auto mt-10 md:px-20 lg:px-32 text-white"></div>
    </div>
  );
};

export default CardHeader;
